import { useSession } from "./useSupabase"

export const useAuth = () => {
  const managementTeam = {
    "felipe.nunes@teracapital.com.br": "Felipe Nunes",
    "rafael.rocha@teracapital.com.br": "Rafael Rocha",
    "adri.costa@teracapital.com.br": "Adri Costa",
    "italo.nunes@teracapital.com.br": "Italo Nunes",
    "joao.vaz@teracapital.com.br": "João Vaz",
    "pedro.monteiro@teracapital.com.br": "Pedro Monteiro",
    "luca.slerca@teracapital.com.br": "Luca Slerca",
    "zwend.martins@teracapital.com.br": "Zwend Martins",
  }

  const session = useSession()

  const isManagementTeam = managementTeam[session.user.email] !== undefined

  const name = managementTeam[session.user.email] || session.user.email

  const relationshipTeam = {
    "isabella.buazar@teracapital.com.br": "Isabella Buazar",
    "augusto.basilio@teracapital.com.br": "Augusto Basilio",
    "larissa.alves@teracapital.com.br": "Larissa Alves",
    "jonas.rinaldelli@teracapital.com.br": "Jonas Rinaldelli",
  }

  const isRelationshipTeam = relationshipTeam[session.user.email] !== undefined

  return { isManagementTeam, name, isRelationshipTeam }
}
